import { ITriggerWhenActivityInData, triggerWhenActivityInUtils } from "./ITriggerWhenActivityIn"
import { useTranslation, useProxyWatch } from "@fanfanlo"
import { Box, Grid2, Stack, Button } from "@mui/material"
import { useRouter } from "next/router"
import { childToProjectDataUtils, IChildToProjectData } from "@droid/project-v2-interface"
import { IActionOrTriggerListPageParams, ActionOrTriggerListTypeEnum } from "@app/static"

export function UI(data: ITriggerWhenActivityInData) {
    const { t } = useTranslation('droid-project-v2-ext/triggers/app/when-activity-in/content')
    const router = useRouter()
    const backPath = router.pathname
    const [pn] = useProxyWatch(data, "javaData.pn", data.javaData.pn)
    const [an] = useProxyWatch(data, "javaData.an", data.javaData.an)
    const [cn] = useProxyWatch(data, "javaData.cn", data.javaData.cn)

    function onChangeClick() {
        const projectInfo: IChildToProjectData = {}
        childToProjectDataUtils.triggerList.getTriggerListByProp(data, projectInfo)
        // 修改：属性从 .id 改为 .ulid，URL参数名从 xxxId 改为 xxxUlid
        if (!projectInfo.project?.ulid || !projectInfo.triggerActionGroup?.ulid || !projectInfo.triggerAction?.ulid || !projectInfo.triggerGroup?.ulid) {
            console.error('UpdateAppLink projectInfo is undefined', projectInfo)
            return
        }

        const query: IActionOrTriggerListPageParams = {
            backPath,
            projectUlid: projectInfo.project?.ulid,
            triggerActionGroupUlid: projectInfo.triggerActionGroup?.ulid,
            triggerActionUlid: projectInfo.triggerAction?.ulid,
            triggerGroupUlid: projectInfo.triggerGroup?.ulid,
            type: ActionOrTriggerListTypeEnum.updateAction,
            triggerUlid: data.ulid,
            triggerType: triggerWhenActivityInUtils.type,
        }
        triggerWhenActivityInUtils.onClickChange?.({ query })
    }

    return (
        <>
            <Box sx={{ width: '100%' }}>
                <Box>
                    <b>{t('UI.title')}</b>
                </Box>
                <Grid2 container sx={{ width: '100%' }}>
                    <Grid2 size="grow" container>
                        <Stack direction="column" spacing={2}>
                            <Box>
                                <span>{t('UI.pnLabel')}</span>
                                <span>{pn}</span>
                            </Box>
                            <Box>
                                <span>{t('UI.anLabel')}</span>
                                <span>{an}</span>
                            </Box>
                            <Box>
                                <span>{t('UI.cnLabel')}</span>
                                <span>{cn}</span>
                            </Box>
                        </Stack>
                    </Grid2>
                    <Grid2 size={"auto"}>
                        <Button data-testid="WhenActivityInUI__changeButton__01JFXYZJ1Z5A6B7C8D9E0F1G2" onClick={onChangeClick}>
                            <span>{t('UI.changeBtnLabel')}</span>
                        </Button>
                    </Grid2>
                </Grid2>
            </Box>
        </>
    )
}
